export const FETCH_LOGIN_REQUEST = 'FETCH_LOGIN_REQUEST'
export const FETCH_LOGIN_SUCCESS = 'FETCH_LOGIN_SUCCESS'
export const FETCH_LOGIN_FALUIRE = 'FETCH_LOGIN_FALUIRE'
export const FETCH_CLEAR_ERROR_MESSAGE_FALUIRE = 'FETCH_CLEAR_ERROR_MESSAGE_FALUIRE'
